import { ActionReducer } from '@ngrx/store';

import { LocalStorageConfig, localStorageSync } from 'ngrx-store-localstorage';

import { StoreKey } from './fetch-from-local-storage.helper';

interface ExtendedLocalStorageConfig extends LocalStorageConfig {
    keys: StoreKey[]; // type-safe strings
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    const keys: ExtendedLocalStorageConfig = {
        keys: ['token', 'functionality', 'authentication', 'user', 'organisation', 'oauth']
    };
    return localStorageSync(keys)(reducer);
}
